<template>
  <v-row>
    <v-col cols="8">
      <h3>{{ $t('multiDayDiscountOverwriteModal.basicPriceOverview') }}</h3>
    </v-col>
    <v-col cols="12">
      <v-row>
        <v-col
          v-for="(discount, index) in successiveMultiDayDiscounts"
          :key="index"
          cols="12"
          class="d-flex justify-space-between"
        >
          <span class="caption white-opacity-text">
            {{ discount.date | formatDate }}
          </span>
          <span class="caption white-opacity-text">
            {{ discount.dailyBaseRate | currency }}
          </span>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'DailyBaseRateHelpTooltip',
  props: {
    /**
     * array of MultiDayDiscount objects
     */
    successiveMultiDayDiscounts: {
      required: true,
      type: Array,
    },
  },
})
</script>
